import { render } from "./inbc.vue?vue&type=template&id=92bbead6&scoped=true"
import script from "./inbc.vue?vue&type=script&lang=js"
export * from "./inbc.vue?vue&type=script&lang=js"

import "./inbc.vue?vue&type=style&index=0&id=92bbead6&lang=less&scoped=true"
import "./inbc.vue?vue&type=style&index=1&id=92bbead6&scoped=true&lang=scss"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92bbead6"]])

export default __exports__